import { render } from "./text-pillars3.vue?vue&type=template&id=3a4287e4&scoped=true"
const script = {}

import "./text-pillars3.vue?vue&type=style&index=0&id=3a4287e4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4287e4"],['__file',"src/views/other/cssfx/components/text-pillars3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a4287e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a4287e4', __exports__)) {
    console.log('reload')
    api.reload('3a4287e4', __exports__)
  }
  
  module.hot.accept("./text-pillars3.vue?vue&type=template&id=3a4287e4&scoped=true", () => {
    console.log('re-render')
    api.rerender('3a4287e4', render)
  })

}


export default __exports__